<template>
  <v-navigation-drawer
    v-model="notiDrawer"
    absolute
    temporary
    right
    hide-overlay
    width="370"
    style="z-index: 12"
  >
    <v-card-title>{{ $t("actionCenter").toUpperCase() }}</v-card-title>
    <template v-for="(item, index) in notiArray">
      <v-col cols="12" sm="12" v-bind:key="index">
        <v-card outlined @click="goToProgress()" style="cursor: pointer;">
          <v-col cols="12" sm="12">
            <v-row align="center">
              <v-col lg="1" sm="1" md="1" xs="1" cols="1">
                <v-icon :color="colorTheme" style="font-size: 30px">{{
                  item.icon
                }}</v-icon>
              </v-col>
              <v-col lg="10" sm="10" md="10" xs="10" cols="11">
                <v-col cols="12" sm="12" style="padding: 0; margin-left: 10px">
                  <p
                    style="
                      text-align: start;
                      width: 100%;
                      margin: 0;
                      font-weight: bold;
                      font-size: 18px;
                      cursor: auto !important;
                    "
                  >
                    {{ item.title }}
                  </p>
                </v-col>
                <v-col cols="12" sm="12" style="padding: 0; margin-left: 10px">
                  <p
                    style="
                      text-align: start;
                      width: 100%;
                      margin: 0;
                      cursor: auto !important;
                    "
                  >
                    {{ item.subtitle }}
                  </p>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
    </template>
  </v-navigation-drawer>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "actionCenter",
  data: () => ({}),
  created() {
  },
  mounted() {},
  computed: {
    ...mapState([
      "colorTheme",
      "notiDrawer",
      "notiArray"
    ]),
  },
  methods: {
    goToProgress() {
      this.$router.push({ name: "configurationProgress" });
    }
  }
};
</script>

<style></style>